import {Component, ContentChild, HostBinding, Input} from "@angular/core";
import {FUIIconComponent} from "../../icons/icon/icon.component";

@Component({
    selector: "fui-action",
    styleUrls: ["./action.component.scss"],
    templateUrl: "./action.component.html",
    standalone: false
})
export class FUIActionComponent {
    @ContentChild(FUIIconComponent) public icon: FUIIconComponent;
    @Input() forceIcon: boolean;
    @Input() public title: string;
    @HostBinding("class.disabled") @Input() public disabled: boolean;

    get useIcon(): boolean {
        return !!this.icon || this.forceIcon;
    }
}
